import { Injectable } from "@angular/core";
import { QuestionnaireService } from "src/app/services/open/questionnaire.service";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, mergeMap } from "rxjs/operators";
import {
	UPDATED_QUESTIONNAIRE_CHECK,
	UPDATED_QUESTIONNAIRE_INPUT,
	UPDATED_QUESTIONNAIRE_RADIO,
	UPDATED_QUESTIONNAIRE_SLIDER,
	UPDATE_QUESTIONNAIRE,
	UPDATE_QUESTIONNAIRE_CHECK,
	UPDATE_QUESTIONNAIRE_INPUT,
	UPDATE_QUESTIONNAIRE_RADIO,
	UPDATE_QUESTIONNAIRE_SLIDER,

} from "../../actions/open/questionnaire.actions";
import { Questionnaire } from "../../models/open/questionnaire.model";
import { EMPTY } from "rxjs/internal/observable/empty";

@Injectable()
export class QuestionnaireEffects {


	// loadMovies$ = createEffect(() => this.actions$.pipe(
	// 	ofType('[Movies Page] Load Movies'),
	// 	mergeMap(() => this.moviesService.getAll()
	// 	  .pipe(
	// 		map(movies => ({ type: '[Movies API] Movies Loaded Success', payload: movies })),
	// 		catchError(() => EMPTY)
	// 	  ))
	// 	)
	//   );

	updateReponseRadio$ = createEffect(() =>
		this.actions$.pipe(
			ofType(UPDATE_QUESTIONNAIRE_RADIO),
			mergeMap((a) => this.questionnaireService.updateReponse(a)
				.pipe(
					map(questionnaire => {
						// console.log(questionnaire);
						return { type: UPDATED_QUESTIONNAIRE_RADIO, questionnaire: questionnaire};
					}),
					catchError(() => EMPTY)
				)
			))
    
		
		// this.actions$.pipe(
		// 	ofType(UPDATE_QUESTIONNAIRE_RADIO),
		// 	mergeMap((a) => {

	
		// 		// return this.questionnaireService.updateReponse(a).pipe(
		// 		// 	map((questionnaire) => {
		// 		// 		return { type: UPDATE_QUESTIONNAIRE, questionnaire: questionnaire  };
		// 		// 	})
		// 		// );
		// 	})
		// )
	);

	updateReponseSlider$ = createEffect(() =>
		this.actions$.pipe(
			ofType(UPDATE_QUESTIONNAIRE_SLIDER),
			mergeMap((a) => {
				return this.questionnaireService.updateReponse(a).pipe(
					map((questionnaire) => {
						return { type: UPDATED_QUESTIONNAIRE_SLIDER, questionnaire: questionnaire };
					})
				);
			})
		)
	);

	updateReponseInput$ = createEffect(() =>
		this.actions$.pipe(
			ofType(UPDATE_QUESTIONNAIRE_INPUT),
			mergeMap((a) => {
				return this.questionnaireService.updateReponse(a).pipe(
					map((questionnaire) => {
						return { type: UPDATED_QUESTIONNAIRE_INPUT, questionnaire: questionnaire };
					})
				);
			})
		)
	);

	updateReponseCheck$ = createEffect(() =>
		this.actions$.pipe(
			ofType(UPDATE_QUESTIONNAIRE_CHECK),
			mergeMap((a) => {
				return this.questionnaireService.updateReponseCheck(a).pipe(
				// return this.questionnaireService.updateReponseCheck(a).pipe(
					map((questionnaire) => {
						return { type: UPDATED_QUESTIONNAIRE_CHECK, questionnaire: questionnaire };
					})
				);
			})
		)
	);

	constructor(private actions$: Actions, private questionnaireService: QuestionnaireService) {}
}


